import React from "react";
import { Link } from "react-router-dom";
import Signup from "../components/Login/Signup";
import register from "../components/Login/Media/Login.json";
import Lottie from "lottie-react";
import TopBar from "../components/TopBar";
import ProgressBar from "../components/ProgressBar";
function Register() {
  return (
    <div>
      <ProgressBar />
      <TopBar />
      <div className="container-fluid">
        <div className="row">
          <div className="hidden md:flex col-12 col-md-6 flex flex-col justify-center align-items-center login-left">
            <Lottie
              animationData={register}
              loop
              autoplay
              style={{
                width: "300px",
                height: "300px",
                background: "transparent",
                scale: 5,
              }}
            />
            <h1 className="text-[32px] text-white">Already have an account?</h1>
            <p className="text-[18px] text-white w-[60%] text-center mt-[20px]">
              Login to your account to get the trendy .gold domains before it is
              too late!
            </p>
            <Link to="/Login" className="mt-[30px] ">
              <button className="join-btn custom-btn main-buttonn w-full !mt-[16px]">
                Login
              </button>
            </Link>
          </div>
          <div className="col-12 col-md-6  login-right pattern-bg2">
            {" "}
            <Signup />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
